const MONTH_LABELS = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

export const formatPeriodYM = (ym: string): string => {
  const monthIdx = Number(ym.slice(5, 7)) - 1;
  return `${MONTH_LABELS[monthIdx]}/${ym.slice(0, 4)}`;
};

export const formatPct = (value: number | null | undefined): string =>
  value == null ? '–' : `${value.toFixed(2)}%`;

export const PERCENT_FORMATTER = (value: number | null | undefined): string =>
  value == null ? 'Sem dado' : `${value.toFixed(2)}%`;

export const SIGNED_PERCENT_FORMATTER = (
  value: number | null | undefined,
): string => {
  if (value == null) return 'Sem dado';
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
};
